function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.091h30v21.818H0V4.091Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.136h30v3.409H0v-3.409ZM0,20.455h30v3.409H0v-3.409Z",
    style: {
      fill: "#0038b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,19.724l-1.364-2.362h-2.727l1.364-2.362-1.364-2.362h2.727l1.364-2.362,1.364,2.362h2.727l-1.364,2.362,1.364,2.362h-2.727l-1.364,2.362ZM14.502,17.362l.498.862.498-.862h-.996ZM16.797,16.612h.995l-.498-.862-.497.862ZM14.069,16.612h1.861l.931-1.612-.931-1.612h-1.861l-.93,1.612.93,1.612ZM12.208,16.612h.995l-.498-.862-.497.862ZM12.208,13.388l.498.862.498-.862h-.996ZM16.797,13.388l.498.862.498-.862h-.996ZM14.502,12.638h.995l-.497-.862-.498.862Z",
    style: {
      fill: "#0038b8"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/IL.868aac73848da8364b2f026c43f4edc5.svg";
export { ForwardRef as ReactComponent };